export default __webpack_public_path__ + "static/media/matthew_wang.23c6a65a.gif";